function cloneTiles(tiles) {
  return tiles.map(rowTiles =>
    rowTiles.map(tile => ({ ...tile }))
  );
}

export {
  cloneTiles,
};


// WEBPACK FOOTER //
// ./src/reducers/util.js